import LeadMagnetHeroTeaser from '@/components/leadmagnet/LeadMagnetHeroTeaser';

export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Professional%20modern%20office%20scene%20with%20new%20employee%20being%20welcomed%20by%20mentor%20and%20team%2C%20warm%20natural%20lighting%2C%20clean%20corporate%20aesthetic%2C%20friendly%20atmosphere%2C%20glass%20walls%2C%20modern%20workspace%2C%20professional%20business%20photography%2C%20soft%20shadows%2C%20people%20smiling%20and%20collaborating%2C%20onboarding%20and%20adaptation%20concept%2C%20bright%20and%20airy%20environment&width=1600&height=900&seq=onboarding-hero-1&orientation=landscape"
          alt="Адаптация новых сотрудников — наставник встречает нового члена команды"
          className="absolute top-1/2 left-1/2 w-[177.77777778vh] min-w-full h-[56.25vw] min-h-full -translate-x-1/2 -translate-y-1/2 object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-28 md:pt-20 pb-10 md:pb-16">
        <div className="max-w-3xl">
          <div className="text-left">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white mb-3 leading-tight">
              Адаптация новых сотрудников
            </h1>
            <p className="text-xl md:text-2xl lg:text-3xl font-bold text-teal-300 mb-5 leading-snug">
              Почему адаптация сотрудников влияет на прибыль компании сильнее, чем кажется
            </p>
            <p className="text-base md:text-lg text-white/85 mb-8 leading-relaxed">
              Первые недели работы определяют, станет ли сотрудник сильным членом команды или покинет компанию. Грамотная система адаптации сокращает текучесть, ускоряет выход на результат и повышает вовлечённость.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-4">
              <button
                onClick={() => scrollTo('contact')}
                className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
              >
                Внедрить систему адаптации
                <i className="ri-arrow-right-line"></i>
              </button>
              <LeadMagnetHeroTeaser />
            </div>
            <p className="text-white/60 text-sm md:text-base font-medium">
              С понятной системой адаптации новичок выходит на результат за 30 дней.
            </p>
          </div>


        </div>
      </div>
    </section>
  );
}